import { OfferPageFormDataWithName } from '@features/Funnel/screens/FunnelPage/OfferPage/OfferPageScreen';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import OpenNotification from 'src/app/components/antd/OpenNotification';

import { apiCancellationFunnels } from '../../api';
import { offerPayloadFactory } from '../../utils/offerFunnelsPagesFactory';

export function useTryToRequestCreatingOfferFunnelPage() {
  const navigate = useNavigate();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: async (payload: OfferPageFormDataWithName) => {
      const factory = await offerPayloadFactory(payload);

      return await apiCancellationFunnels.tryToRequestCreatingOffer(factory);
    },
    onSuccess: () => {
      navigate(-1);
    },
    onError: () => {
      OpenNotification(
        true,
        'Erro ao criar o funil de Oferta',
        'Ocorreu um erro ao criar o funil de Oferta, por favor tente novamente mais tarde.'
      );
    },
  });

  return {
    tryToRequestCreatingOfferFunnelPage: mutateAsync,
    isLoadingCreateOfferFunnelPage: isPending,
  };
}
